import { Container, Box, Typography, Button, Stack } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useState, useEffect } from 'react';
import { getFeaturedEvent } from '../firebase/firestore';

function FeaturedEvent() {
    const [featuredEvent, setFeaturedEvent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadFeaturedEvent = async () => {
            try {
                const event = await getFeaturedEvent();
                setFeaturedEvent(event);
            } catch (error) {
                console.error('Błąd podczas ładowania featured eventu:', error);
            } finally {
                setLoading(false);
            }
        };

        loadFeaturedEvent();
    }, []);

    // Jeśli nie ma featured eventu lub nie jest aktywny, nie wyświetlaj komponentu
    if (loading || !featuredEvent || !featuredEvent.isActive) {
        return null;
    }

    return (
        <Container maxWidth='auto' sx={{ p: 3, position: 'relative', overflow: 'hidden' }}>
            <Box sx={{
                background: 'linear-gradient(to right, rgba(76, 29, 149, 0.9), rgba(17, 24, 39, 1));',
                zIndex: '10',
                position: 'absolute',
                inset: '0px',
            }}></Box>
            {featuredEvent.backgroundImage && (
                <Box component="img"
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        inset: '0px',
                        height: '100%',
                        objectFit: 'cover',
                        display: { xs: 'none', sm: 'block' }, // Ukryj obrazek na urządzeniach mobilnych
                    }}
                    src={featuredEvent.backgroundImage}>
                </Box>
            )}
            <Box sx={{
                color: 'white',
                borderRadius: 2,
                zIndex: '20',
                position: 'relative',
            }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" gap={1}>
                    <Container>
                        <Typography sx={{
                            color: 'rgb(239, 68, 68);',
                            fontWeight: '600',
                            marginBottom: '0.5rem',
                            height: '24px',
                        }}>
                            FEATURED EVENT
                        </Typography>
                        <Typography variant="h2" component="h2" gutterBottom sx={{
                            fontSize: { xs: '1.5rem', sm: '1.875rem' }, // Dostosuj rozmiar czcionki na urządzeniach mobilnych
                            lineHeight: { xs: '1.75rem', sm: '2.25rem' },
                            fontWeight: '700',
                            marginBottom: '1rem',
                        }}>
                            {featuredEvent.title}
                        </Typography>
                        <Box sx={{
                            color: 'rgb(196, 181, 253);',
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            marginBottom: '1rem',
                        }}>
                            {featuredEvent.date && (
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <EventIcon fontSize='small'></EventIcon>
                                    <Typography component="span" sx={{ marginRight: '0.5rem' }}>
                                        {featuredEvent.date}
                                    </Typography>
                                </Stack>
                            )}
                            {featuredEvent.location && (
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <LocationOnIcon fontSize='small'></LocationOnIcon>
                                    <Typography component="span" sx={{ marginRight: '0.5rem' }}>
                                        {featuredEvent.location}
                                    </Typography>
                                </Stack>
                            )}
                            {featuredEvent.prizes && (
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <EmojiEventsIcon fontSize='small'></EmojiEventsIcon>
                                    <Typography component="span" sx={{ marginRight: '0.5rem' }}>
                                        {featuredEvent.prizes}
                                    </Typography>
                                </Stack>
                            )}
                        </Box>
                        {featuredEvent.description && (
                            <Typography variant="body1" gutterBottom sx={{ display: { xs: 'none', sm: 'block' } }}>
                                {featuredEvent.description}
                            </Typography>
                        )}
                        <Stack direction="row" alignItems="center" gap={1} sx={{ mt: 2 }}>
                            {featuredEvent.registrationUrl && (
                                <Button variant="contained" sx={{
                                    backgroundColor: 'rgb(220, 38, 38);',
                                    color: 'white',
                                    paddingTop: '0.75rem',
                                    paddingBottom: '0.75rem',
                                    paddingLeft: '1.5rem',
                                    paddingRight: '1.5rem',
                                    borderRadius: '0.5rem',
                                }}
                                    href={featuredEvent.registrationUrl} target='_blank'>
                                    Rejestracja
                                </Button>
                            )}
                            {featuredEvent.detailsUrl && (
                                <Button variant="outlined" sx={{
                                    color: 'white',
                                    paddingTop: '0.75rem',
                                    paddingBottom: '0.75rem',
                                    paddingLeft: '1.5rem',
                                    paddingRight: '1.5rem',
                                    borderRadius: '0.5rem',
                                }}
                                    href={featuredEvent.detailsUrl} target='_blank'>
                                    Szczegóły
                                </Button>
                            )}
                        </Stack>
                    </Container>
                    {featuredEvent.eventImage && (
                        <Container sx={{ display: { xs: 'none', sm: 'block' } }}>
                            <Box component="img" src={featuredEvent.eventImage}
                                sx={{
                                    maxHeight: '300px',
                                    borderRadius: '0.5rem',
                                }}>
                            </Box>
                        </Container>
                    )}
                </Stack>
            </Box>
        </Container >
    );
}

export default FeaturedEvent;